export default "__VITE_ASSET__cb8f6514__"